import React, { useEffect } from 'react'
import HomePage from './pages/HomePage'
import { useUser } from './lib/useUser'
import { redirectToLogin } from './lib/api'
import { detectInitialLocale, t } from './i18n'

function LoadingScreen({ locale }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-white">
      <div className="flex items-center gap-3 text-sm text-gray-600">
        <div
          className="h-5 w-5 animate-spin rounded-full border-2 border-gray-200 border-t-corendon-red"
          aria-label={t(locale, 'loading')}
        />
        <span>{t(locale, 'loading')}</span>
      </div>
    </div>
  )
}

function AuthGate({ locale }) {
  useEffect(() => {
    const timer = window.setTimeout(redirectToLogin, 250)
    return () => window.clearTimeout(timer)
  }, [])
  return (
    <div className="flex min-h-full items-center justify-center bg-white p-6 text-center">
      <div className="max-w-sm">
        <p className="text-sm text-gray-600">{t(locale, 'errorAuthRequired')}</p>
        <button
          type="button"
          onClick={redirectToLogin}
          className="mt-4 inline-flex items-center justify-center rounded-full bg-corendon-red px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-corendon-red-dark"
        >
          {t(locale, 'loginButton')}
        </button>
      </div>
    </div>
  )
}

export default function App() {
  const user = useUser()
  const locale = detectInitialLocale()

  if (user === undefined) return <LoadingScreen locale={locale} />
  if (user === null) return <AuthGate locale={locale} />
  return <HomePage user={user} />
}
